import RPMPatientDiagnoses from './patient-diagnoses';
import './patient-diagnoses.less';

export default RPMPatientDiagnoses;
